import Numeral from 'numeral'

export default {
    cash,
    number,
    percent
}

function cash(value) {
    return Numeral(value).format('$0,0.00')
}

function number(value) {
    return Numeral(value).format('0,0')
}

function percent(value) {
    return Numeral(value).format('0.000%')
}